import { AsyncComponentLoader, inject, InjectionKey } from 'vue';

export const layoutsKey: InjectionKey<Record<string, AsyncComponentLoader>> = Symbol('Helix Layouts');

export function useHLayouts() {
  const layouts = inject(layoutsKey);

  if (!layouts) {
    throw new Error('Helix layouts are not provided. Please ensure you have provided the layouts using useProvideHLayouts.');
  }

  return layouts;
}
